import { useContext } from 'react';

import { Context } from '../contexts/flagContext';

// eslint-disable-next-line import/prefer-default-export
export const useFlagContext = () => useContext(Context);
